import { Box } from "@mui/material";
import ViewDetailsIcon from "../../../../../Assets/Icons/view-details-icon.png";

export const columns = [
  {
    field: "employeeName",
    headerName: "Employee Name",
    width: 400,
  },
  { field: "deviceImei", headerName: "Device ID", width: 220 },
  {
    field: "totalOrders",
    headerName: "Total Orders",
    width: 180,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "orderLines",
    headerName: "Order Lines",
    width: 140,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "totalItems",
    headerName: "Total Items",
    width: 200,
    align: "center",
    headerAlign: "center",
  },
  // {
  //   field: "action",
  //   headerName: "Action",
  //   width: 120,
  //   renderCell: (params) => (
  //     <Box>
  //       <img
  //         src={ViewDetailsIcon}
  //         alt="View Details icon"
  //         style={{ cursor: "pointer" }}
  //         onClick={() =>
  //           params.api.getRowParams(params.id).row.handleRowClick(params)
  //         }
  //       />
  //     </Box>
  //   ),
  // },
];
